import { useRoutes } from 'react-router-dom'
import { mainRoutes } from 'routes/main'
import './index.css'

export default function App() {
  const app = useRoutes(mainRoutes)
  return app
}
